export enum PaymentMethod {
  None = 0,
  Card = 1,
  Onsite = 2,
}

export enum PaymentMethodText {
  None = 'none',
  Card = 'card',
  Onsite = 'onsite',
}
